import React, { useEffect, useState } from 'react'
import dynamic from 'next/dynamic'
import { intl } from 'src/i18n'
import { InnerLoader } from 'src/components/InnerLoader'
import styles from './styles.module.scss'

const TradingViewWidgetComponent = dynamic(
  () => import('react-tradingview-widget'),
  { ssr: false }
)

export const TradingViewWidget = ({ symbol }) => {
  const [loading, setLoading] = useState(true)
  const [tradingViewSymbol, setTradingViewSymbol] = useState()
  const pair = tradingViewSymbol?.split(':')[1]

  useEffect(() => {
    setLoading(true)
    getTradingViewSymbol(symbol)
      .then(setTradingViewSymbol)
      .finally(() => setLoading(false))
  }, [symbol])

  if (loading)
    return (
      <div className={styles.container}>
        <InnerLoader />
      </div>
    )

  if (!tradingViewSymbol) {
    return (
      <div className={styles.container}>
        <div className={styles.empty}>{intl.t('noData')}</div>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <TradingViewWidgetComponent
        symbol={tradingViewSymbol}
        theme='Dark'
        autosize
        interval='D'
        style='1'
        locale='en'
        toolbar_bg='#1d1d1e'
        details={false}
        allow_symbol_change
        hide_side_toolbar={false}
        enable_publishing={false}
        withdateranges
        show_popup_button
      />

      <div className={styles.link}>
        <a
          href={`https://www.tradingview.com/symbols/${pair}`}
          target='_blank'
          rel='noopener noreferrer'
        >
          {tradingViewSymbol} Chart
        </a>{' '}
        by TradingView
      </div>
    </div>
  )
}

const getTradingViewSymbol = async symbol => {
  const rawResponse = await fetch(
    'https://scanner.tradingview.com/crypto/scan',
    {
      method: 'POST',
      body: JSON.stringify({
        filter: [
          {
            left: 'market_cap_calc',
            operation: 'nempty',
          },
          {
            left: 'name',
            operation: 'match',
            right: '^' + symbol,
          },
        ],
        columns: ['exchange', 'name'],
        sort: {
          sortBy: 'market_cap_calc',
          sortOrder: 'desc',
        },
      }),
    }
  )

  if (rawResponse.status !== 200) {
    return
  }

  const response = await rawResponse.json()
  if (response.totalCount <= 0) {
    return
  }

  const exchanges = response.data.reduce((result, i) => {
    result[i.d[0]] = i.s
    return result
  }, {})

  return exchanges['BINANCE'] || exchanges['COINBASE'] || exchanges['KRAKEN']
}

export default TradingViewWidget
